import { joinNames } from '../helpers';
import styles from './style.module.scss';

type BarStyle = '100%' | '50%' | '0%';
type Bar = {
    legend?: string;
    value: number;
    style: BarStyle;
};
type StackedBarChartProps = { bars: Bar[] };

export default function StackedBarChart({ bars }: StackedBarChartProps) {
    const total = bars.reduce((acc, b) => acc + b.value, 0);
    return (
        <div className={styles.stack}>
            {bars
                .filter((b) => b.value > 0)
                .map((b, i) => (
                    <div
                        key={i}
                        className={joinNames(styles.bar, getBarSubClass(b), maybeWithLegend(b))}
                        title={b.value.toString()}
                        style={{
                            width: `${(b.value * 100) / total}%`,
                            zIndex: 900 - i,
                        }}
                        data-legend={b.legend}
                    ></div>
                ))}
        </div>
    );
}
function getBarSubClass(bar: Bar): string | undefined {
    switch (bar.style) {
        case '100%':
            return styles.bar100;
        case '50%':
            return styles.bar50;
        case '0%':
            return styles.bar0;
        default:
            return undefined;
    }
}
function maybeWithLegend(bar: Bar): string | undefined {
    return bar.legend ? styles.barWithLegend : undefined;
}
